export const getPrintPaginationStyles = (rootSelector: string) => `
  @media print {
    @page {
      size: A4 portrait;
      margin: 18mm 12mm 16mm;

      /* Empty generated boxes suppress Chromium's default headers and footers. */
      @top-left {
        content: "";
      }

      @bottom-left {
        content: "";
      }
    }

    html,
    body {
      min-width: 0 !important;
    }

    ${rootSelector} {
      min-width: 0 !important;
      min-height: 0 !important;
      height: auto !important;
    }

    ${rootSelector} .react-form-builder-form {
      display: block !important;
      height: auto !important;
      min-height: 0 !important;
      aspect-ratio: auto !important;
      overflow: visible !important;
    }

    ${rootSelector} .rfb-item,
    ${rootSelector} .SortableItem,
    ${rootSelector} [class*="form-group"],
    ${rootSelector} [data-print-keep-together],
    ${rootSelector} tr,
    ${rootSelector} figure,
    ${rootSelector} .signature-pad,
    ${rootSelector} .image-upload-container {
      break-inside: avoid !important;
      page-break-inside: avoid !important;
    }

    ${rootSelector} h1,
    ${rootSelector} h2,
    ${rootSelector} h3,
    ${rootSelector} h4,
    ${rootSelector} label,
    ${rootSelector} legend {
      break-after: avoid !important;
      page-break-after: avoid !important;
    }

    ${rootSelector} p {
      orphans: 3;
      widows: 3;
    }

    ${rootSelector} img,
    ${rootSelector} canvas {
      break-inside: avoid !important;
      page-break-inside: avoid !important;
      max-height: 250mm !important;
    }

    ${rootSelector} thead {
      display: table-header-group !important;
    }

    ${rootSelector} tfoot {
      display: table-row-group !important;
    }
  }
`;
